export default __webpack_public_path__ + "static/media/warning--road-bump-with-speed-limit--g1.7be1fee6.png";